module.exports = __webpack_public_path__ + "static/media/ss3_preview.823bba1f.jpg";